export enum EditingPresentRole {
    /** 主讲人 */
    host = 'HOST',
    /** 参会者 */
    audience = 'AUDIENCE'
}

export interface IEditingPresentManager {
    role?: EditingPresentRole;
    isPresentFollowing: boolean;
    hostAvatar: string;
    hostSlideId: string
    startPresentFollow(): void;
    endPresentFollow(): void;
    getSlideIndex(): { hostSlideIndex: number, localSlideIndex: number };
}
